var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('contract.handover.headline')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('contract.handover.paragraph_one')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('contract.handover.paragraph_two')))]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/contract/HandoverOutput.vue?vue&type=template&id=00a5e3fb&
// module id = null
// module chunks = 